/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Plates_Bar_OnlyInputs */

const en_us2_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The bar alone`)
};

const pt_br2_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a barra`)
};

const es_419_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo la barra`)
};

const pt_pt2_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só a barra`)
};

const fr_fr2_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La barre seule`)
};

const de_de2_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur die Stange`)
};

const it_it2_workout_logging_plates_bar_only = /** @type {(inputs: Workout_Logging_Plates_Bar_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo il bilanciere`)
};

/**
* | output |
* | --- |
* | "The bar alone" |
*
* @param {Workout_Logging_Plates_Bar_OnlyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_bar_only = /** @type {((inputs?: Workout_Logging_Plates_Bar_OnlyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_Bar_OnlyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_bar_only(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_bar_only(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_bar_only(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_bar_only(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_bar_only(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_bar_only(inputs)
	return en_us2_workout_logging_plates_bar_only(inputs)
});
export { workout_logging_plates_bar_only as "workout-logging.plates_bar_only" }